import CardPm from 'components/CardPm';
import Layout from 'Layout'
import React, { useCallback } from 'react'
import List from 'components/List';
import { useState } from 'react';
import { getMisi, getVisi } from 'services/apiRoutes';
import { useEffect } from 'react';
import HorizontalCard from 'components/HorizontalCard';
import ImVisi from 'assets/images/im-visi.jpg'
import { useParams } from 'react-router-dom';

export default function VisiMisi() {
  const { slug } = useParams();

  const [visi,setVisi] = useState(null);
  const [misi,setMisi] = useState(null)


  const visiAPI = useCallback(async()=>{
    const res = await getVisi(slug);
    if(res.error){
      return res.message;
    }else{
      const {data} = res.data
      setVisi(data);
    }
  },[slug])

  const misiAPI = useCallback(async()=>{
    const res = await getMisi(slug);
    if(res.error){
      return res.message;
    }else{
      const {data} = res.data
      setMisi(data);
    }
  },[slug])


  useEffect(() => {
    visiAPI();
    misiAPI();
  }, [visiAPI, misiAPI]);

  return (
    <Layout>
      <div className="px-5 xl:pt-48 pt-28 kegiatan-wrapper xl:px-99">
        {/* <h1 className="text-2xl font-bold xl:text-7xl">Visi Misi</h1> */}
        <h1 className="text-2xl font-bold xl:mb-18 mb-14 xl:text-7xl">
          Visi Misi
        </h1>
        <div className="space-y-24 wrapperCad">
          <HorizontalCard
            // desc="90% Masyarakat Gampong Geulanggang teungoh adalah Petani"
            title="Visi Misi"
            img={ImVisi}
          />
        </div>
        <div className="my-20 wrapperCard">
          {visi
            ? visi?.map((item, index) => (
                <CardPm
                  key={index}
                  img={item?.url_gambar}
                  cardVisi
                  post={item?.visi}
                />
              ))
            : null}
        </div>
        <h1 className="text-2xl font-bold text-secondary xl:text-7xl">Misi</h1>
        <div className="p-4 my-20 mb-32 space-y-5 wrapperDescBatas rounded-2xl bg-blurBorder xl:p-7">
          {misi
            ? misi?.map((item, index) => (
                <List cardPm list={item?.misi} key={index} />
              ))
            : null}

          {/* <List
            cardPm
            list="Mewujudkan Masyarakat yang Beriman, Bertaqwa dan berakhlakul Karimah."
          /> */}
          {/* <List
            cardPm
            list="Mewujudkan Sumber Daya Manusia yang Berilmu Pengetahuan, Sehat Lahir Batin."
          />
          <List
            cardPm
            list="Mewujudkan Sumber Daya Aparatur Gampong yang profesional, Dinamis dan bermoral."
          />
          <List
            cardPm
            list="Meningkatkan Peran dan Pemberdayaan Masyarakat dalam Pembangunan Gampong Sesuai Hak dan kewajiban."
          />
          <List
            cardPm
            list="Meningkatkan Kualitas Pelayanan Pendidikan, kesehatan daan Daya Saing Sektor Pertanian, Perindustrian dan perdagangan."
          />
          <List
            cardPm
            list="Mewujudkan Kondisi Gampong yang Berkualitas dan Bebas KKN dan Profesional dalam Rangka Good Governance."
          />
          <List
            cardPm
            list="Penanggulangan Kemiskinan dan Meningkatkan Taraf Hidup Masyarakat Gampong Dengan Mengembangkan Pembangunan Ekonomi Melalui Badan Usaha Milik Gampong (BUMG)."
          />
          <List
            cardPm
            list="Menata dan Mengembangkan Potensi Kebudayaan, Pariwisata yang Islami, Mengutamakan Musyawarah dan Mufakat dalam menyelesaikan Berbagai Masalah."
          /> */}
        </div>
      </div>
    </Layout>
  );
}
